const updateDisplay = display => dispatch => {
  dispatch({
    type: "UPDATE_DISPLAY",
    payload: display
  });
};

export default updateDisplay;



// WEBPACK FOOTER //
// ./src/actions/display.js